import type { CollectionCardConfig, CollectionItem } from '@/lib/blocks/collection/blocks';
import { getEnabledFields, getImageField } from '@/lib/blocks/collection/blocks';
import type {
  PinnedBlogFieldOptions,
  PinnedCaseResultFieldOptions,
} from '@/lib/blocks/collection/index-collection/field-renderer-types';
import type { IndexCollectionLayout } from '@/lib/blocks/collection/index-collection/layout';
import { isIndexPinnedCollectionBlock } from '@/lib/blocks/collection/index-collection/registry';
import { readImageUrl } from '@/lib/prop-utils';
import type { PageBlock } from '@/types/block';

export function readIndexPinnedBlogFieldOptions(
  block: Pick<PageBlock, 'blockType' | 'props'>,
  layout: IndexCollectionLayout,
): PinnedBlogFieldOptions | undefined {
  if (!isIndexPinnedCollectionBlock(block)) return undefined;
  if (layout !== 'list') return undefined;

  return {
    titleClassName: 'text-h1 font-extrabold leading-tight tracking-normal text-white',
    summaryClassName: 'text-base leading-7 text-white/85',
  };
}

export function resolveBlogIndexRenderField({
  block,
  cardConfig,
  layout,
  item,
}: {
  block: Pick<PageBlock, 'blockType' | 'props'>;
  cardConfig: CollectionCardConfig;
  layout: IndexCollectionLayout;
  item: CollectionItem;
}) {
  const pinned = readIndexPinnedBlogFieldOptions(block, layout);
  if (!pinned) {
    return { variant: 'index' as const, pinned: undefined };
  }

  const imageField = getImageField(getEnabledFields(cardConfig.fields));
  const hasImage = Boolean(imageField && readImageUrl(item[imageField.slot]));
  if (!hasImage) {
    return { variant: 'index' as const, pinned: undefined };
  }

  return { variant: 'pinned' as const, pinned };
}

export function readIndexPinnedCaseResultFieldOptions(
  block: Pick<PageBlock, 'blockType' | 'props'>,
  layout: IndexCollectionLayout,
): PinnedCaseResultFieldOptions | undefined {
  if (!isIndexPinnedCollectionBlock(block)) return undefined;

  return {
    denseDetailRows: layout === 'split',
  };
}
